export default __webpack_public_path__ + "static/media/lpm-reg-bg-bright-fixed.65b186e1.jpg";